// extracted by mini-css-extract-plugin
export default {"statusBadge":"StatusField_statusBadge__9ICHH"};